import VideoBackground from 'components/video-background'
import { AFTERWORK_ASSETS, AFTERWORK_IMAGES, AFTERWORK_VIDEOS } from '../constants'

// Hero (Figma 43:101): bottle video background with the Afterwork by
// Heineken lockup over the bottom black gradient. While the dedicated logo
// exports are missing on the CDN (batch upload pending), onError swaps to
// the home experience-card lockup, which is already live.
const Hero = () => {
  return (
    <section className="afterwork__hero">
      <VideoBackground
        className="afterwork__hero-media"
        src={`${AFTERWORK_ASSETS}/${AFTERWORK_VIDEOS.hero}`}
      />
      <div className="afterwork__hero-fade" aria-hidden="true" />
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={encodeURI(`${AFTERWORK_ASSETS}/${AFTERWORK_IMAGES.heroLogoDesktop}`)}
        />
        <img
          className="afterwork__hero-logo"
          src={encodeURI(`${AFTERWORK_ASSETS}/${AFTERWORK_IMAGES.heroLogoMobile}`)}
          alt="Afterwork by Heineken"
          onError={(event) => {
            const img = event.currentTarget
            const fallback = encodeURI(`${AFTERWORK_ASSETS}/${AFTERWORK_IMAGES.heroLogoFallback}`)
            if (!img.src.endsWith(AFTERWORK_IMAGES.heroLogoFallback.replace(/ /g, '%20'))) {
              img.parentElement?.querySelector('source')?.remove()
              img.src = fallback
            }
          }}
        />
      </picture>
    </section>
  )
}

export default Hero
